import LibraryView from "views/LibraryView";

export default function Page() {
  return (
    <>
      <LibraryView />
    </>
  );
}
